import { defineNamespace, ConsumerTypes, ApiVersions } from '../../common';
import { platformAPICreator as platformAPICreatorV2Blocks, } from './refComponents.panel-builder.v2';
export * from './refComponents.super';
export const namespaceCreator = defineNamespace((config) => {
    if (config.consumerType === ConsumerTypes.PanelBuilder &&
        config.version === ApiVersions.V2) {
        return platformAPICreatorV2Blocks(config.superAPI)(config.context);
    }
    return null;
});
//# sourceMappingURL=index.js.map